<template lang="pug">
  d2-container
    el-form(:inline="true" :model="dataForm" size="mini" label-width="75px" label-position="right" :modal-append-to-body="false" label-suffix=":")
      el-row(:span="24")
        el-col(:md="7" :sm="12")
          el-form-item(label="俱乐部名")
            el-input.inputWidth(v-model="dataForm.oldName" placeholder="请输入俱乐部名" clearable)
        el-col(:md="7" :sm="12")
          el-form-item(label="申请时间")
            el-date-picker.inputWidth(
              v-model="dataForm.publishTime"
              style="width: 218px;"
              range-separator="至"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            )
        el-col(:md="7" :sm="12")
          el-form-item(label="状态" label-width="75px")
            el-select.inputWidth(v-model="dataForm.status" clearable)
              el-option(label="待审核" :value="1")
              el-option(label="已拒绝" :value="3")
      el-row(style="padding-bottom: 15px;" :span="24")
        el-col(:md="1" :sm="14" style="float: right;")
          el-button(type="primary" icon="el-icon-search" style="float: right;" @click="queryList()") 查 询
    el-table(:data="tableData" style="width: 100%;" v-loading="dataListLoading" border)
      el-table-column(prop="oldName" header-align="center" align="center" label="俱乐部名称")
      el-table-column(prop="newName" header-align="center" align="center" label="俱乐部新名称")
      el-table-column(prop="chairman" header-align="center" align="center" label="会长" )
      el-table-column(prop="chairmanId" header-align="center" align="center" label="会长账号")
      el-table-column(prop="createTime" header-align="center" align="center" label="申请时间" width="180" sortable)
      el-table-column(prop="status" header-align="center" align="center" label="状态" width="100")
        template(slot-scope="scope")
          font(v-if="scope.row.status === 1")
            span.danger()
            span() &nbsp; 待审批
          font(v-if="scope.row.status === 3")
            span.warning()
            span() &nbsp; 已拒绝
      el-table-column(header-align="center" align="center" label="操作" width="100")
        template(slot-scope="scope")
          el-menu.menuPonit(:collapse="isCollapse" )
            el-submenu(index="1")
              template(slot="title")
                i(class="el-icon-more" style="color: #02B90D;")
              el-menu-item-group()
                el-menu-item(index="1-1" @click="suspend(scope.row.id, 1)" v-if="isAuth('ct:renameList:agree')") 同意申请
                el-menu-item(index="1-2" @click="suspend(scope.row.id, 2)" v-if="isAuth('ct:renameList:noagree')") 拒绝申请
    el-pagination(
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    )
    el-dialog(
      title="拒绝理由"
      class="el-dialog-custom"
      width="30%"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :append-to-body="true"
      @close="closeDialog"
    )
      el-form(ref="refuse_ref" :inline="true" :model="refuse_form" :rules="refuse_rules")
        el-form-item(label="拒绝理由：" prop="number")
          el-input(v-model="refuse_form.number" type="textarea" style="width: 400px;" :rows="5" maxlength="300" show-word-limit resize="none" placeholder="请输入拒绝理由")
      span.dialog-footer(slot="footer")
        el-button(@click="closeDialog") 返 回
        el-button(type="primary" @click="submit") 提 交
</template>

<script>
export default {
  name: 'ct-competition-registerlist',
  data () {
    return {
      isCollapse: true,
      pageIndex: 1,
      pageSize: 10,
      tableData: '',
      totalPage: '',
      dataForm: {
        oldName: '',
        status: '',
        publishTime: []
      },
      visible: false,
      refuse_form: {
        id: '',
        number: ''
      },
      refuse_rules: {
        number: [{ required: true, message: '请输入拒绝理由', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.getDataList()
  },
  methods: {
    queryList () {
      this.pageIndex = 1
      this.getDataList()
    },
    // 分页
    sizeChangeHandle (val) {
      this.pageIndex = 1
      this.pageSize = val
      this.getDataList()
    },
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    tongyi (id, status) {
      this.$http({
        url: this.$http.adornUrl(`/cbRenameHistory/update`),
        method: 'post',
        data: {
          id: id,
          status: status
        }
      }).then((data) => {
        if (data && data.code === 0) {
          this.$message({ message: '操作成功', type: 'success' })
          // this.closeDialog()
          this.getDataList()
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    suspend (id, sum) {
      if (sum === 1) {
        this.$confirm('是否同意申请？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false
        }).then(() => {
          this.tongyi(id, 2)
        })
      }
      if (sum === 2) {
        // this.visible = true
        // this.refuse_form.id = id
        this.$confirm('是否拒绝申请？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false
        }).then(() => {
          this.tongyi(id, 3)
        })
      }
    },
    closeDialog (done) {
      this.$refs.refuse_ref.resetFields()
      this.visible = false
      if (typeof (done) === 'function') done()
    },
    submit () {
			this.$refs.refuse_ref.validate(valid => {
				if (valid) {
          this.tongyi(this.refuse_form.id, 3)
        }
      })
    },
    getDataList () {
      this.dataListLoading = true
      let data = {
        oldName: this.dataForm.oldName,
        strDate: this.dataForm.publishTime && this.dataForm.publishTime[0] ? this.dataForm.publishTime[0] : '',
        endDate: this.dataForm.publishTime && this.dataForm.publishTime[1] ? this.dataForm.publishTime[1] : '',
        page: this.pageIndex,
        limit: this.pageSize,
        status: this.dataForm.status
      }
      this.$http({
        url: this.$http.adornUrl('/cbRenameHistory/list'),
        method: 'post',
        data: data
      }).then(data => {
        if (data && data.code === 0) {
          this.tableData = data.page.records
          this.totalPage = data.page.total
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    }
  }
}
</script>

<style>
/* 操作三点 菜单样式 */
@import "../../../../css/opr3dot.css";

.inputWidth {
  width: 210px;
}

.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}

/* 提示框 */
.el-tooltip__popper.is-light {
  border: 1px solid #c0c4cc;
}

.el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: grey !important;
}

.toolTip>p {
  margin: 0;
  padding-top: 10px;
  height: 14px;
  line-height: 14px;
  font-size: 14px;
  color: #606266;
}

.el-dialog-custom .el-textarea__inner {
  font-family: inherit;
}
</style>
